import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_BINS, UPDATE_BINS_SUCCESS, UPDATE_BINS_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* updateBins({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/global-bins`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Bins updated successfully`);
      yield put({
        type: UPDATE_BINS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: UPDATE_BINS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_BINS_ERROR, payload: error });
  }
}

export function* watchUpdateBins() {
  yield takeEvery(UPDATE_BINS, updateBins);
}

function* updateBinsSaga() {
  yield all([fork(watchUpdateBins)]);
}

export default updateBinsSaga;
